import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { styled } from "@material-ui/styles";
import { useApplicationDetails } from "../hooks/useApplicationDetails";
import { useAuthentication } from "../hooks/useAuthentication";
import { getQueryConfiguration } from "../utils";
import AuthenticationDialog from "./Authentication/AuthenticationDialog";
import ApplicationBanners from "./Common/ApplicationBanners";
import Dashboard from "./Dashboard/Dashboard";
import NavBar from "./NavBar/NavBar";

const BUILD_DATE = `${process.env.REACT_APP_VERSION}`;

const StyledContent = styled("div")(({ theme }) => ({
    margin: theme.spacing(2, 1, 1),
}));

const UnauthenticatedDialog = ({ mode }) => {
    const MODES = {
        fg: "requesting password reset",
        new: "registering",
    };

    return <AuthenticationDialog open={true} mode={MODES[mode]} />;
};

const Main = () => {
    const { title, splashMessage, footerMessage } = useApplicationDetails();

    const authentication = useAuthentication();

    const { mode, forceAuthenticationMode } = getQueryConfiguration();

    useEffect(() => {
        document.title = title;
        console.log(BUILD_DATE);
    }, [title]);

    return (
        <>
            <NavBar />

            {authentication.user && !forceAuthenticationMode ? (
                <StyledContent>
                    <ApplicationBanners splashMessage={splashMessage} footerMessage={footerMessage}>
                        <Routes>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="*" element={<Navigate to="dashboard" replace />} />
                        </Routes>
                    </ApplicationBanners>
                </StyledContent>
            ) : (
                <UnauthenticatedDialog mode={mode} />
            )}
        </>
    );
};

export default Main;
